<script setup lang="ts">
import {apiClient} from "@/api/http.ts";
import {onMounted, ref, watch} from "vue";

const props = defineProps({
  entityId: {
    required: true,
    type: Number,
  }
})
type File = {
  id: number
  title: string
  fileName?: string
  contentUrl?: string
}
const files = ref<File[]>([])
const loadFiles = async () => {
  if (props.entityId) {
    apiClient.get('wiser/getFiles/'+props.entityId).then((res) => {
      files.value = res.data
    })
  }
}
onMounted(() => {
  loadFiles()
})
watch(
  () => props.entityId,
  loadFiles
)
const parseContentUrl = (url: string) => {
  if (url.startsWith("http")) {
    return url
  }
  return 'file://' + url
}
</script>

<template>
  <div class="model-list--Document wiser-detail__description files-detail__description" v-if="files.length ?? 0 > 0">
    <h3>Documenten</h3>
    <ul class="model-list__items model-list-offer">
      <li v-for="(file, index) in files" :key="index" class="model-list model-list-item">
        <a :href="parseContentUrl(file.contentUrl)" download v-if="file.contentUrl">{{ file.id }}: {{ file.title }}</a>
        <span v-else>{{ file.title }}</span>
      </li>
    </ul>
  </div>
</template>

<style scoped>

</style>
